import {css, Theme} from "@emotion/react";
import {fontFace} from "@rw/global_styles";

import {BrowserSupportView} from "../app/components/BrowserSupportView";
import {currentStaticsDir} from "../app/constants/current_statics_dir";

/** Self-hosted Nunito Sans (latin + latin-ext for Polish). Served from /static-cars/fonts/. */
const fontFolder = "nunito_sans";
const fontFamily = "Nunito Sans";
const fontPath = `/${currentStaticsDir}/fonts/${fontFolder}/`;

// unicode-range from @fontsource/nunito-sans
const LATIN =
    "U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD";
const LATIN_EXT =
    "U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF";

const nunitoFontFaces = [400, 500, 600, 700]
    .map((weight) =>
        [
            fontFace(fontPath, fontFamily, `latin-${weight}-normal`, String(weight), "normal", "swap", LATIN),
            fontFace(fontPath, fontFamily, `latin-ext-${weight}-normal`, String(weight), "normal", "swap", LATIN_EXT)
        ].join("\n")
    )
    .join("\n");

export const globalStylesCars = (theme: Theme) => css`
    ${nunitoFontFaces};

    /**
    based on weather "align-items" is supported by browser or not we show/hide browser upgrade message to a user.
    Because "align-items" has the closest correlation to expected browsers compatibility it is being used as indicator.
     */
    @supports not (align-items: center) {
        body {
            overflow: hidden;
        }
        ${BrowserSupportView} {
            display: block !important;
        }
    }

    /*
    Code below should work in case of IE10+, @supports doesn't work there, in order to show BrowserSupportView it needs to be set with @media.   
    */
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        body {
            overflow: hidden;
        }
        ${BrowserSupportView} {
            display: block !important;
        }
    }
`;
